module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "footer-wrap"
  }, [_c('div', {
    staticClass: "footer__shaodw"
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container text-center"
  }, [_c('h1', {
    staticClass: "square"
  }, [_vm._v("ABOUT COMPANY")]), _vm._v(" "), _c('div', {
    staticClass: "introduction"
  }, [_c('p', [_vm._v("北京伟嘉安捷投资担保有限公司成立于2006年3月15日。")]), _vm._v(" "), _c('p', [_vm._v("是一家为个人提供房产按揭引荐服务、房产权证服务的专业机构，注册资金为5000万元。")]), _vm._v(" "), _c('p', [_vm._v("专业性是伟嘉安捷最大的特点。")]), _vm._v(" "), _c('p', [_vm._v("公司拥有一支精通金融理财、政策法规及房地产专业知识的精英队伍，致力于为借款人提供全面的贷款经纪及按揭理财服务。")]), _vm._v(" "), _c('p', [_vm._v("伟嘉安捷依托深厚的房地产从业背景、坚实的银行合作基础、大量优质的客户，自成立之初至现在占据了较大的市场份额。")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "copy"
  }, [_vm._v("\n      © 2019 "), _c('span', [_vm._v("北京伟嘉安捷投资担保有限公司")]), _vm._v(" All rights reserved   |   京ICP备16040229号-2   |   "), _c('a', {
    staticClass: "credentials",
    attrs: {
      "href": "//image.91weijia.com/91weijia/PublicLicense/credentials.html",
      "target": "_blank"
    }
  }, [_vm._v("证照公示")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3ef9f61c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/footer.vue
// module id = 596
// module chunks = 1